<template>
  <div class="original animate__animated init--zzQhF" id="ycGame">
    <div class="original_box maxWidth">
      <div class="original-main">
        <div class="original-main-title">
          <div class="yc">原创游戏展示</div>
          <div></div>
        </div>
        <div class="accordion">
          <div v-for="(item, index) in gameVideoList" @mouseleave="mouseLeaveHandler(index)"
            @mouseenter="prepare(index)" @mouseover='mouseover(index)' :key="index"
            :class="item.flag ? 'variation' : 'shade_box'">
            <div class="accordion_box2">
              <video v-if="item.reset" :controls="item.flag" :ref="`video${index}`" preload="metadata" :src="item.url"
                :poster="item.cover" :autoplay="false" muted></video>
              <div class="play" :ref="`play${index}`" :class="item.show ? '' : 'playNone'" @click="playVideo(index)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      gameVideoList: [],
    };
  },
  created() { },
  mounted() {
    this.videoReset();
  },
  computed: {
    ...mapState({
      engineMediaList: (state) => state.init.engineMediaList,
    })
  },
  watch: {
    engineMediaList: {
      handler(val) {
        let arr = []
        for (let index = 0; index < val.length; index++) {
          const item = val[index];
          let flag = false;
          if(index==0){
            flag = true
          }
          arr.push({
            show: true,
            flag: flag,
            reset: true,
            url:item.media,
            cover: item.img,
          })
         
        }
        this.gameVideoList = arr;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //原创游戏展示 视频播放
    playVideo(index) {
      let sun = index;
      this.gameVideoList.forEach((item) => {
        item.show = true;
      });
      this.gameVideoList[index].show = false;
      this.gameVideoList.forEach((item, index) => {
        if (sun != index) {
          this.$refs[`video${index}`][0].load();
        }
      });
      if (this.$refs[`video${index}`][0].paused) {
        this.$refs[`video${index}`][0].play();
      } else {
        this.$refs[`video${index}`][0].pause();
      }
    },
    // 鼠标移入自动播放
    mouseover(index) {
      if (this.$refs[`video${index}`][0].paused) {
        this.$refs[`play${index}`][0].click(index)
      }
      // this.$refs[`play${index}`][0].click(index)
      // console.log(,'xxxxxxx');
    },
    //原创游戏展示 鼠标移入视频
    prepare(index) {
      this.gameVideoList.forEach((item, value) => {
        item.flag = false;
      });
      this.gameVideoList[index].flag = true;
    },
    //原创游戏展示 鼠标移出视频
    mouseLeaveHandler(index) {
      try {
        // this.gameVideoList[index].show = true;
        // this.gameVideoList[index].reset = false;
        // setTimeout(() => {
        //   this.gameVideoList[index].reset = true;
        // }, 0);
      } catch (error) { }
    },
    //原创游戏展示 视频播放完重置
    videoReset() {
      this.gameVideoList.forEach((item, index) => {
        this.$refs[`video${index}`][0].addEventListener("play", () => {
          this.gameVideoList[index].show = false;
        });
        // ended 视频播放结束
        this.$refs[`video${index}`][0].addEventListener("ended", () => {
          this.gameVideoList[index].show = true;
          this.$refs[`video${index}`][0].load();
          this.gameVideoList[index].reset = false;
          setTimeout(() => {
            this.gameVideoList[index].reset = true;
          }, 0);
        });
        // 视频暂停
        this.$refs[`video${index}`][0].addEventListener("pause", () => {
          // this.$refs[`video${index}`][0].load()
          this.gameVideoList[index].show = true;
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.original {
  height: 10.6375rem
    /* 851/80 */
  ;

  position: relative;
  z-index: 2;
  background: #323232;
}

.original_box {
  height: 100%;
  background: url("../../assets/images/pc/origina.jpg") no-repeat center;
  background-size: cover;
}

.original-main .original-main {
  margin-left: 4.5rem
    /* 360/80 */
  ;
}

.original-main .original-main-title {
  text-align: center;
}

.original-main .original-main-title div:nth-child(1) {
  font-size: 0.45rem
    /* 36/80 */
  ;
  color: #fcfcfc;
  padding-top: 0.75rem
    /* 60/80 */
  ;
  margin-bottom: 0.3125rem
    /* 25/80 */
  ;
}

.original-main .original-main-title div:nth-child(2) {
  width: 10.875rem
    /* 870/80 */
  ;
  height: 0.0125rem
    /* 1/80 */
  ;
  background: #c9c9c9;
  box-sizing: border-box;
  margin: 0 auto;
  background: linear-gradient(to right, #3b3b3b, #a4a4a4 50%, #3b3b3b);
}

.accordion {
  margin: 0 auto;
  margin-top: 1.3rem
    /* 104/80 */
  ;
  display: flex;
  // justify-content: space-between;
  width: 15.275rem
    /* 1222/80 */
  ;
}

.accordion>div {
  border-radius: 0.1875rem
    /* 15/80 */
  ;
  width: 2.1125rem
    /* 169/80 */
  ;
  height: 5.5875rem
    /* 447/80 */
  ;
  cursor: pointer;
  transition: all 0.3s linear;
  background: #000000;
  display: flex;
}
.accordion>div+div{
  margin-left: .2rem /* 16/80 */;
}
.accordion>div video {
  margin: auto 0;
  width: 100%;
  height: 100%;
  border-radius: 0.1875rem
    /* 15/80 */
  ;
  object-fit: cover;
}

/* 隐藏全部控件 */
/* .accordion>div video::-webkit-media-controls-enclosure{ 
	display: none;
} */

/* 播放按钮 */
/* .accordion>div video::-webkit-media-controls-play-button {
      display: none !important;
    } */
/* 当前播放时间 */
.accordion>div video::-webkit-media-controls-current-time-display {
  display: none !important;
}

/* 剩余时间 */
.accordion>div video::-webkit-media-controls-time-remaining-display {
  display: none !important;
}

/* 音量按钮 */
/* video::-webkit-media-controls-volume-control-container {
      display: none !important;
    } */
/* 全屏 */
/* video::-webkit-media-controls-fullscreen-button {
      display: none !important;
    } */
/* 时间轴 */
video::-webkit-media-controls-timeline {
  display: none !important;
}

.original .original-main .accordion .variation {
  width: 8.15rem
    /* 652/80 */
  ;
  position: relative;
}

.variation video {
  opacity: 0.7;
}

.accordion_box2 {
  width: 100%;
  position: relative;
}

.accordion .accordion_center {
  position: relative;
  margin: auto;
}

.accordion .shade_box {
  position: relative;
}

.accordion .shade_box::after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 101%;
  opacity: 0.85;
  background: #6b150b;
  border-radius: 0.1875rem
    /* 15/80 */
  ;
}

.accordion .variation::after {
  /* content: ""; */
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;
  opacity: 0.27;
  background: #000;
  border-radius: 0.1875rem
    /* 15/80 */
  ;
}

.accordion .variation .play {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 1.1625rem
    /* 93/80 */
  ;
  height: 1.175rem
    /* 94/80 */
  ;
  background: url("../../assets/images/pc/play.png") no-repeat center;
  background-size: cover;
  z-index: 3;
}

.accordion .variation .playNone {
  display: none;
}
</style>
